__turbopack_context__.v({
  "loaderContainer": "styles-module__qWclRG__loaderContainer",
  "spin": "styles-module__qWclRG__spin",
  "spinner": "styles-module__qWclRG__spinner",
});
